import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LoanDetail from './components/loan-detail';
import LandingPage from './components/landing-page';
import MakePayment from './components/make-payment';
import SetUpAutopay from './components/set-up-autopay';
import ConnectBank from './components/connect-bank';
import TurnOffAutoPay from './components/turn-off-autopay';
import AutopayTerms from './components/autopay-terms';
import TransactionHistory from './components/transaction-history/TransactionHistory';
import ErrorLandingPage from './components/error-landing-page';
import AccountModal from './AccountModal';
import Header from './Header';
import Footer from './Footer';
import OneTimePasswordModal from './OneTimePasswordModal';
import GatedRoute from "./router/GatedRoute";

export default function Routes() {
  return (
    <>
      <Header />
      {/* NOTE(2024/02): these are development only components and should be removed. */}
      {/*<AccountModal />*/}
      {/*<OneTimePasswordModal />*/}

      <Switch>
        <Route path="/" exact component={LandingPage} />
        <Route path="/my-cars" exact component={LandingPage} />
        <Route path="/loan-detail/:id" exact component={LoanDetail} />
        <GatedRoute
          path="/loan-detail/make-payment/:id"
          exact
        >
          <MakePayment />
        </GatedRoute>
        <Route
          path="/loan-detail/set-up-autopay/:id"
          exact
          component={SetUpAutopay}
        />
        <Route
          path="/loan-detail/connect-bank/:id"
          exact
          component={ConnectBank}
        />
        <Route
          path="/loan-detail/turn-off-autopay/:id"
          exact
          component={TurnOffAutoPay}
        />
        <Route
          path="/loan-detail/set-up-autopay/autopay-terms/:id"
          exact
          component={AutopayTerms}
        />
        <Route
          path="/loan-detail/transaction-history/:id"
          exact
          component={TransactionHistory}
        />
        <Route path="/error-landing-page/" exact component={ErrorLandingPage} />
      </Switch>

      <Footer />
    </>
  );
}
